import React from "react"
import { RichText } from "prismic-reactjs"
import styled from "@emotion/styled"
import PropTypes from "prop-types"

const TextCardContainer = styled("div")`
  margin-bottom: 120px;
  transition: all 150ms ease-in-out;

  text-decoration: none;
  color: currentColor;

  h3 {
    margin-bottom: 40px;
  }

  @media (max-width: 950px) {
    margin: 0 32px 120px 32px;

    & h3 {
      margin: 0px;
    }
  }
`

const TextCardContent = styled("div")`
  width: 100%;
  overflow: hidden;
  background: white;

  column-count: 2;
  column-gap: 120px;

  h3 {
    width: 100%;
  }

  .block-img {
    text-align: center;

    & img {
      max-height: 50vh;
      margin-bottom: 32px;
      margin-top: 32px;
    }
  }

  @media (max-width: 950px) {
    width: 100%;
    padding: 32px 0 0 0;
    column-count: 1;
  }
`

const TextCard = ({ subline, title, description, thumbnail }) => {
  return (
    <TextCardContainer className="imageWrapper">
      {RichText.render(title)}
      {subline && <h6>{subline[0].text}</h6>}
      <TextCardContent>{RichText.render(description)}</TextCardContent>
    </TextCardContainer>
  )
}

export default TextCard

TextCard.propTypes = {
  title: PropTypes.array.isRequired,
}
